import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { BookOpen, Search, Plus, Edit2, Trash2, X, Filter, Users, User, MapPin, ChevronLeft, MoveRight, Save, ArrowLeftRight } from 'lucide-react';
import AuroraFloatingCard from '../ui/AuroraFloatingCard';
import { Link, useNavigate } from 'react-router-dom';
// Sınıf veri tipi tanımı
interface Class {
  id: number;
  grade: string;
  section: string;
  fullName: string;
  location: string;
  classTeacherId: number | null;
  studentCount: number;
  status: boolean;
}
// Öğretmen veri tipi tanımı
interface Teacher {
  id: number;
  firstName: string;
  lastName: string;
  branch: string;
  status: boolean;
}
// Öğrenci veri tipi tanımı
interface Student {
  id: number;
  firstName: string;
  lastName: string;
  classId: number | null;
}
// Sınıf seviyesi seçenekleri
const gradeOptions = ['5', '6', '7', '8', '9', '10', '11', '12'];
// Şube seçenekleri
const sectionOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
// Mock öğretmen verileri
const mockTeachers: Teacher[] = [{
  id: 1,
  firstName: 'Ayşe',
  lastName: 'Yılmaz',
  branch: 'Matematik',
  status: true
}, {
  id: 2,
  firstName: 'Mehmet',
  lastName: 'Demir',
  branch: 'Fen Bilimleri',
  status: true
}, {
  id: 3,
  firstName: 'Zeynep',
  lastName: 'Kaya',
  branch: 'Türkçe',
  status: true
}, {
  id: 4,
  firstName: 'Ahmet',
  lastName: 'Şahin',
  branch: 'İngilizce',
  status: true
}, {
  id: 5,
  firstName: 'Fatma',
  lastName: 'Çelik',
  branch: 'T.C. İnkılap Tarihi ve Atatürkçülük',
  status: true
}, {
  id: 6,
  firstName: 'Hasan',
  lastName: 'Yıldız',
  branch: 'Din Kültürü ve Ahlâk Bilgisi',
  status: true
}, {
  id: 7,
  firstName: 'Emre',
  lastName: 'Kılıç',
  branch: 'Matematik',
  status: true
}, {
  id: 8,
  firstName: 'Selin',
  lastName: 'Öztürk',
  branch: 'Fen Bilimleri',
  status: true
}, {
  id: 9,
  firstName: 'Burak',
  lastName: 'Aksoy',
  branch: 'Türkçe',
  status: true
}, {
  id: 10,
  firstName: 'Deniz',
  lastName: 'Aydın',
  branch: 'İngilizce',
  status: true
}];
// Örnek öğrenci verileri
const mockStudents: Student[] = [{
  id: 1,
  firstName: 'Ahmet',
  lastName: 'Yılmaz',
  classId: 1
}, {
  id: 2,
  firstName: 'Ayşe',
  lastName: 'Demir',
  classId: 1
}, {
  id: 3,
  firstName: 'Mehmet',
  lastName: 'Kaya',
  classId: 1
}, {
  id: 4,
  firstName: 'Zeynep',
  lastName: 'Şahin',
  classId: 1
}, {
  id: 5,
  firstName: 'Mustafa',
  lastName: 'Öztürk',
  classId: 2
}, {
  id: 6,
  firstName: 'Elif',
  lastName: 'Yıldız',
  classId: 2
}, {
  id: 7,
  firstName: 'Emre',
  lastName: 'Aydın',
  classId: 2
}, {
  id: 8,
  firstName: 'Selin',
  lastName: 'Çelik',
  classId: 2
}, {
  id: 9,
  firstName: 'Burak',
  lastName: 'Koç',
  classId: 3
}, {
  id: 10,
  firstName: 'Deniz',
  lastName: 'Aksoy',
  classId: 3
}, {
  id: 11,
  firstName: 'Aylin',
  lastName: 'Yücel',
  classId: 3
}, {
  id: 12,
  firstName: 'Cem',
  lastName: 'Türk',
  classId: 3
}, {
  id: 13,
  firstName: 'Defne',
  lastName: 'Acar',
  classId: 4
}, {
  id: 14,
  firstName: 'Ege',
  lastName: 'Kılıç',
  classId: 4
}, {
  id: 15,
  firstName: 'Funda',
  lastName: 'Eren',
  classId: 4
}, {
  id: 16,
  firstName: 'Gökhan',
  lastName: 'Bilgin',
  classId: 5
}, {
  id: 17,
  firstName: 'Hande',
  lastName: 'Yavuz',
  classId: 5
}, {
  id: 18,
  firstName: 'İrem',
  lastName: 'Doğan',
  classId: 5
}, {
  id: 19,
  firstName: 'Kaan',
  lastName: 'Arslan',
  classId: 6
}, {
  id: 20,
  firstName: 'Levent',
  lastName: 'Güneş',
  classId: 6
}, {
  id: 21,
  firstName: 'Mine',
  lastName: 'Korkmaz',
  classId: 6
}, {
  id: 22,
  firstName: 'Nazlı',
  lastName: 'Tekin',
  classId: 7
}, {
  id: 23,
  firstName: 'Oğuz',
  lastName: 'Yalçın',
  classId: 7
}, {
  id: 24,
  firstName: 'Pelin',
  lastName: 'Şener',
  classId: 7
}, {
  id: 25,
  firstName: 'Rıza',
  lastName: 'Tunç',
  classId: 8
}, {
  id: 26,
  firstName: 'Seda',
  lastName: 'Güzel',
  classId: 8
}, {
  id: 27,
  firstName: 'Tarık',
  lastName: 'Özkan',
  classId: 8
}, {
  id: 28,
  firstName: 'Ufuk',
  lastName: 'Erdem',
  classId: null
}, {
  id: 29,
  firstName: 'Vildan',
  lastName: 'Kara',
  classId: null
}, {
  id: 30,
  firstName: 'Yusuf',
  lastName: 'Aslan',
  classId: null
}];
// Örnek sınıf verileri
const initialClasses: Class[] = [{
  id: 1,
  grade: '8',
  section: 'A',
  fullName: '8-A',
  location: 'A Blok - 101',
  classTeacherId: 3,
  studentCount: 22,
  status: true
}, {
  id: 2,
  grade: '8',
  section: 'B',
  fullName: '8-B',
  location: 'A Blok - 102',
  classTeacherId: 5,
  studentCount: 19,
  status: true
}, {
  id: 3,
  grade: '7',
  section: 'A',
  fullName: '7-A',
  location: 'A Blok - 103',
  classTeacherId: 1,
  studentCount: 21,
  status: true
}, {
  id: 4,
  grade: '7',
  section: 'B',
  fullName: '7-B',
  location: 'A Blok - 104',
  classTeacherId: 4,
  studentCount: 20,
  status: true
}, {
  id: 5,
  grade: '6',
  section: 'A',
  fullName: '6-A',
  location: 'B Blok - 201',
  classTeacherId: 2,
  studentCount: 23,
  status: true
}, {
  id: 6,
  grade: '6',
  section: 'B',
  fullName: '6-B',
  location: 'B Blok - 202',
  classTeacherId: null,
  studentCount: 18,
  status: true
}, {
  id: 7,
  grade: '5',
  section: 'A',
  fullName: '5-A',
  location: 'B Blok - 203',
  classTeacherId: null,
  studentCount: 24,
  status: true
}, {
  id: 8,
  grade: '5',
  section: 'B',
  fullName: '5-B',
  location: 'B Blok - 204',
  classTeacherId: null,
  studentCount: 20,
  status: true
}];
// Sınıf Listesi Görünümü Bileşeni
const ClassListView = ({
  classes,
  teachers,
  searchTerm,
  setSearchTerm,
  selectedGrade,
  setSelectedGrade,
  setShowAddModal
}) => {
  const [filteredClasses, setFilteredClasses] = useState<Class[]>(classes);
  const navigate = useNavigate();
  // Sınıf arama ve filtreleme
  useEffect(() => {
    let result = classes.filter(cls => cls.status);
    // İsme göre arama
    if (searchTerm) {
      result = result.filter(cls => cls.fullName.toLowerCase().includes(searchTerm.toLowerCase()) || cls.location.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    // Sınıf seviyesine göre filtreleme
    if (selectedGrade) {
      result = result.filter(cls => cls.grade === selectedGrade);
    }
    setFilteredClasses(result);
  }, [searchTerm, selectedGrade, classes]);
  // Sınıf öğretmenini bul
  const findClassTeacher = (teacherId: number | null) => {
    if (!teacherId) return null;
    return teachers.find(t => t.id === teacherId);
  };
  return <div className="space-y-6" data-id="element-1235">
      {/* Üst Kontroller */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4" data-id="element-1236">
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto" data-id="element-1237">
          {/* Arama */}
          <div className="relative" data-id="element-1238">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-1239" />
            <input type="text" placeholder="Sınıf adı ile ara..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-10 pr-4 py-2 w-full sm:w-64 bg-gray-800/50 border border-purple-500/30 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-1240" />
          </div>
          {/* Sınıf Seviyesi Filtresi */}
          <div className="relative" data-id="element-1241">
            <Filter className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-1242" />
            <select value={selectedGrade} onChange={e => setSelectedGrade(e.target.value)} className="pl-10 pr-10 py-2 w-full sm:w-48 bg-gray-800/50 border border-purple-500/30 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent appearance-none" style={{
            backgroundImage: `linear-gradient(rgba(30, 30, 40, 0.4), rgba(20, 20, 30, 0.4))`,
            boxShadow: 'inset 0 1px 1px rgba(255, 255, 255, 0.05)'
          }} data-id="element-1243">
              <option value="" className="bg-gray-800 text-white" data-id="element-1244">
                Tüm Sınıflar
              </option>
              {gradeOptions.map(option => <option key={option} value={option} className="bg-gray-800 text-white" data-id="element-1245">
                  {option}. Sınıflar
                </option>)}
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-1246">
              <svg className="w-5 h-5 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1247">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-1248" />
              </svg>
            </div>
          </div>
        </div>
        {/* Yeni Sınıf Ekle Butonu */}
        <button onClick={() => setShowAddModal(true)} className="px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-500 hover:opacity-90 text-white rounded-lg transition-colors flex items-center gap-2 whitespace-nowrap" data-id="element-1249">
          <Plus size={18} data-id="element-1250" />
          Yeni Sınıf Ekle
        </button>
      </div>
      {/* Sınıf Kartları Grid */}
      {filteredClasses.length === 0 ? <div className="text-center py-12" data-id="element-1251">
          <BookOpen className="w-16 h-16 text-gray-600 mx-auto mb-4" data-id="element-1252" />
          <p className="text-gray-400 mb-4" data-id="element-1253">
            {searchTerm || selectedGrade ? 'Arama kriterlerinize uygun sınıf bulunamadı.' : "Henüz hiç sınıf kaydı bulunmuyor. İlk sınıfı eklemek için '+ Yeni Sınıf Ekle' butonuna tıklayın."}
          </p>
        </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5" data-id="element-1254">
          {filteredClasses.map(cls => {
        const classTeacher = findClassTeacher(cls.classTeacherId);
        return <div key={cls.id} onClick={() => navigate(`/yonetici/siniflar/${cls.id}`)} className="cursor-pointer group" data-id="element-1255">
                <AuroraFloatingCard className="h-full transition-transform duration-200 group-hover:scale-[1.02]" data-id="element-1256">
                  <div className="p-5 flex flex-col h-full" data-id="element-1257">
                    <div className="flex justify-between items-start mb-4" data-id="element-1258">
                      <h3 className="text-2xl font-bold text-white" data-id="element-1259">
                        {cls.fullName}
                      </h3>
                      <div className="p-2 bg-blue-500/10 rounded-lg" data-id="element-1260">
                        <BookOpen className="w-5 h-5 text-blue-400" data-id="element-1261" />
                      </div>
                    </div>
                    {/* Sınıf Öğretmeni */}
                    <div className="mb-4" data-id="element-1262">
                      <p className="text-xs text-gray-400 mb-1" data-id="element-1263">
                        Sınıf Danışmanı
                      </p>
                      {classTeacher ? <div className="flex items-center gap-2" data-id="element-1264">
                          <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center" data-id="element-1265">
                            <span className="text-xs font-bold text-white" data-id="element-1266">
                              {classTeacher.firstName.charAt(0)}
                              {classTeacher.lastName.charAt(0)}
                            </span>
                          </div>
                          <p className="text-sm font-medium text-white" data-id="element-1267">
                            {classTeacher.firstName} {classTeacher.lastName}
                          </p>
                        </div> : <p className="text-sm text-gray-500 italic" data-id="element-1268">
                          Atanmamış
                        </p>}
                    </div>
                    {/* Öğrenci Sayısı */}
                    <div className="mt-auto" data-id="element-1269">
                      <div className="flex items-center gap-2" data-id="element-1270">
                        <Users className="w-4 h-4 text-purple-400" data-id="element-1271" />
                        <p className="text-sm text-gray-300" data-id="element-1272">
                          <span className="font-medium text-white" data-id="element-1273">
                            {cls.studentCount}
                          </span>{' '}
                          Öğrenci
                        </p>
                      </div>
                    </div>
                  </div>
                </AuroraFloatingCard>
              </div>;
      })}
        </div>}
    </div>;
};
// Sınıf Detay Görünümü Bileşeni
const ClassDetailView = ({
  classId,
  classes,
  setClasses,
  teachers,
  students,
  setStudents
}) => {
  const navigate = useNavigate();
  const [currentClass, setCurrentClass] = useState<Class | null>(null);
  const [classStudents, setClassStudents] = useState<Student[]>([]);
  const [unassignedStudents, setUnassignedStudents] = useState<Student[]>([]);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [showAddStudentModal, setShowAddStudentModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [studentToMove, setStudentToMove] = useState<Student | null>(null);
  const [isModified, setIsModified] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  // Form state for editing class
  const [editFormData, setEditFormData] = useState({
    grade: '',
    section: '',
    location: '',
    classTeacherId: ''
  });
  // LGS dersleri ve öğretmen atamaları
  const [subjectTeachers, setSubjectTeachers] = useState({
    turkce: null as number | null,
    matematik: null as number | null,
    fenBilimleri: null as number | null,
    sosyalBilgiler: null as number | null,
    ingilizce: null as number | null,
    dinKulturu: null as number | null
  });
  // Sınıf ve öğrenci verilerini yükle
  useEffect(() => {
    const classData = classes.find(c => c.id === parseInt(classId));
    if (classData) {
      setCurrentClass(classData);
      // Form verilerini mevcut sınıf verileriyle doldur
      setEditFormData({
        grade: classData.grade,
        section: classData.section,
        location: classData.location || '',
        classTeacherId: classData.classTeacherId ? String(classData.classTeacherId) : ''
      });
      // Sınıfa ait öğrencileri filtrele
      const filteredStudents = students.filter(s => s.classId === classData.id);
      setClassStudents(filteredStudents);
      // Atanmamış öğrencileri filtrele
      const filteredUnassigned = students.filter(s => s.classId === null);
      setUnassignedStudents(filteredUnassigned);
      // Örnek olarak rastgele ders öğretmeni atamaları
      // Gerçek uygulamada bu veriler veritabanından gelecektir
      setSubjectTeachers({
        turkce: 3,
        matematik: 1,
        fenBilimleri: 2,
        sosyalBilgiler: 5,
        ingilizce: 4,
        dinKulturu: 6 // Din Kültürü - Hasan Yıldız
      });
    }
  }, [classId, classes, students]);
  // Öğretmen değişikliklerini işle
  const handleTeacherChange = (subject: string, teacherId: string) => {
    setSubjectTeachers(prev => ({
      ...prev,
      [subject]: teacherId ? parseInt(teacherId) : null
    }));
    setIsModified(true);
  };
  // Sınıf bilgilerini düzenleme
  const handleEditClass = () => {
    if (currentClass) {
      const fullName = `${editFormData.grade}-${editFormData.section}`;
      // Aynı isimde başka sınıf var mı kontrol et (kendi dışında)
      const duplicateCheck = classes.find(cls => cls.fullName === fullName && cls.id !== currentClass.id && cls.status);
      if (duplicateCheck) {
        alert(`${fullName} sınıfı zaten mevcut!`);
        return;
      }
      // Sınıfı güncelle
      const updatedClasses = classes.map(cls => cls.id === currentClass.id ? {
        ...cls,
        grade: editFormData.grade,
        section: editFormData.section,
        fullName: fullName,
        location: editFormData.location,
        classTeacherId: editFormData.classTeacherId ? parseInt(editFormData.classTeacherId) : null
      } : cls);
      setClasses(updatedClasses);
      setCurrentClass({
        ...currentClass,
        grade: editFormData.grade,
        section: editFormData.section,
        fullName: fullName,
        location: editFormData.location,
        classTeacherId: editFormData.classTeacherId ? parseInt(editFormData.classTeacherId) : null
      });
      setShowEditModal(false);
      setIsModified(true);
    }
  };
  // Sınıfı silme
  const handleDeleteClass = () => {
    if (currentClass) {
      // Sınıfa ait öğrencilerin sınıf atamasını kaldır
      const updatedStudents = students.map(student => student.classId === currentClass.id ? {
        ...student,
        classId: null
      } : student);
      // Sınıfı kaldır
      const updatedClasses = classes.filter(cls => cls.id !== currentClass.id);
      setStudents(updatedStudents);
      setClasses(updatedClasses);
      // Ana sınıf listesine yönlendir
      navigate('/yonetici/siniflar');
    }
  };
  // Öğrenciyi başka bir sınıfa taşı
  const handleMoveStudent = (targetClassId: number) => {
    if (studentToMove) {
      // Öğrencinin sınıfını güncelle
      const updatedStudents = students.map(s => s.id === studentToMove.id ? {
        ...s,
        classId: targetClassId
      } : s);
      setStudents(updatedStudents);
      // Sınıfların öğrenci sayılarını güncelle
      const updatedClasses = classes.map(c => {
        if (c.id === currentClass?.id) {
          return {
            ...c,
            studentCount: c.studentCount - 1
          };
        }
        if (c.id === targetClassId) {
          return {
            ...c,
            studentCount: c.studentCount + 1
          };
        }
        return c;
      });
      setClasses(updatedClasses);
      // Sınıfa ait öğrencileri güncelle
      setClassStudents(prevStudents => prevStudents.filter(s => s.id !== studentToMove.id));
      setShowMoveModal(false);
      setStudentToMove(null);
      setIsModified(true);
    }
  };
  // Sınıfa öğrenci ekle
  const handleAddStudent = (studentId: number) => {
    // Öğrencinin sınıfını güncelle
    const updatedStudents = students.map(s => s.id === studentId ? {
      ...s,
      classId: currentClass?.id || null
    } : s);
    setStudents(updatedStudents);
    // Seçilen öğrenciyi bul
    const selectedStudent = students.find(s => s.id === studentId);
    if (selectedStudent && currentClass) {
      // Sınıfın öğrenci sayısını güncelle
      const updatedClasses = classes.map(c => c.id === currentClass.id ? {
        ...c,
        studentCount: c.studentCount + 1
      } : c);
      setClasses(updatedClasses);
      // Sınıfa ait öğrencileri güncelle
      setClassStudents(prev => [...prev, {
        ...selectedStudent,
        classId: currentClass.id
      }]);
      // Atanmamış öğrencileri güncelle
      setUnassignedStudents(prev => prev.filter(s => s.id !== studentId));
      setIsModified(true);
    }
  };
  // Öğrenci arama
  const filteredClassStudents = classStudents.filter(student => `${student.firstName} ${student.lastName}`.toLowerCase().includes(searchTerm.toLowerCase()));
  // Değişiklikleri kaydet
  const handleSaveChanges = () => {
    // Burada API çağrısı yapılacak
    alert('Değişiklikler başarıyla kaydedildi!');
    setIsModified(false);
  };
  // Sınıf bilgisi yoksa yükleniyor göster
  if (!currentClass) {
    return <div className="flex justify-center items-center h-64" data-id="element-1274">
        <div className="text-center" data-id="element-1275">
          <p className="text-gray-400" data-id="element-1276">Yükleniyor...</p>
        </div>
      </div>;
  }
  // Sınıf öğretmenini bul
  const classTeacher = teachers.find(t => t.id === currentClass.classTeacherId);
  // Branşa göre öğretmenleri filtrele
  const getTeachersByBranch = (branch: string) => {
    return teachers.filter(t => t.status && t.branch === branch);
  };
  return <div className="space-y-6" data-id="element-1277">
      {/* Üst Başlık, Geri Butonu ve Kaydet Butonu */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6" data-id="element-1278">
        <div className="flex items-center gap-3" data-id="element-1279">
          <button onClick={() => navigate('/yonetici/siniflar')} className="p-2 bg-gray-800/50 rounded-lg text-gray-400 hover:text-white hover:bg-gray-700/50 transition-colors" data-id="element-1280">
            <ChevronLeft size={20} data-id="element-1281" />
          </button>
          <h1 className="text-2xl sm:text-3xl font-bold flex items-center gap-3" data-id="element-1282">
            <span data-id="element-1283">{currentClass.fullName} Sınıfı Yönetimi</span>
          </h1>
        </div>
        {/* Kaydet Butonu */}
        <button onClick={handleSaveChanges} disabled={!isModified} className={`px-4 py-2 rounded-lg flex items-center gap-2 ${isModified ? 'bg-gradient-to-r from-green-600 to-emerald-600 text-white hover:opacity-90' : 'bg-gray-800/50 text-gray-500 cursor-not-allowed'} transition-colors`} data-id="element-1284">
          <Save size={18} data-id="element-1285" />
          Değişiklikleri Kaydet
        </button>
      </div>
      {/* Sınıf Bilgileri ve Ders Öğretmenleri */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1286">
        {/* Sağ Bölüm - Sınıf Bilgileri Kartı */}
        <div data-id="element-1287">
          <AuroraFloatingCard data-id="element-1288">
            <div className="p-5 sm:p-6" data-id="element-1289">
              <div className="flex justify-between items-center mb-4" data-id="element-1290">
                <div className="flex items-center gap-2" data-id="element-1291">
                  <BookOpen className="w-5 h-5 text-blue-400" data-id="element-1292" />
                  <h2 className="text-xl font-bold" data-id="element-1293">Sınıf Bilgileri</h2>
                </div>
                <button onClick={() => setShowEditModal(true)} className="p-1.5 bg-blue-500/10 hover:bg-blue-500/20 text-blue-400 rounded-lg transition-colors" title="Düzenle" data-id="element-1294">
                  <Edit2 size={16} data-id="element-1295" />
                </button>
              </div>
              <div className="space-y-4" data-id="element-1296">
                {/* Sınıf Adı */}
                <div data-id="element-1297">
                  <p className="text-sm text-gray-400" data-id="element-1298">Sınıf Adı</p>
                  <p className="text-lg font-medium text-white" data-id="element-1299">
                    {currentClass.fullName}
                  </p>
                </div>
                {/* Sınıf Danışmanı */}
                <div data-id="element-1300">
                  <p className="text-sm text-gray-400" data-id="element-1301">Sınıf Danışmanı</p>
                  {classTeacher ? <div className="flex items-center gap-2 mt-1" data-id="element-1302">
                      <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center" data-id="element-1303">
                        <span className="text-xs font-bold text-white" data-id="element-1304">
                          {classTeacher.firstName.charAt(0)}
                          {classTeacher.lastName.charAt(0)}
                        </span>
                      </div>
                      <p className="text-sm font-medium text-white" data-id="element-1305">
                        {classTeacher.firstName} {classTeacher.lastName}
                      </p>
                    </div> : <p className="text-sm text-gray-500 italic mt-1" data-id="element-1306">
                      Atanmamış
                    </p>}
                </div>
                {/* Öğrenci Sayısı */}
                <div data-id="element-1307">
                  <p className="text-sm text-gray-400" data-id="element-1308">Öğrenci Sayısı</p>
                  <p className="text-sm text-white mt-1" data-id="element-1309">
                    {currentClass.studentCount} öğrenci
                  </p>
                </div>
              </div>
              {/* Sınıfı Silme Butonu */}
              <div className="mt-8 pt-4 border-t border-gray-700/30" data-id="element-1310">
                <button onClick={() => setShowDeleteModal(true)} className="w-full px-4 py-2 bg-red-500/10 hover:bg-red-500/20 text-red-400 rounded-lg transition-colors flex items-center justify-center gap-2" data-id="element-1311">
                  <Trash2 size={16} data-id="element-1312" />
                  <span data-id="element-1313">Sınıfı Sil</span>
                </button>
              </div>
            </div>
          </AuroraFloatingCard>
        </div>
        {/* Sol Bölüm - Ders Öğretmenleri */}
        <div className="lg:col-span-2" data-id="element-1314">
          <AuroraFloatingCard data-id="element-1315">
            <div className="p-5 sm:p-6" data-id="element-1316">
              <div className="flex items-center gap-2 mb-5" data-id="element-1317">
                <User className="w-5 h-5 text-purple-400" data-id="element-1318" />
                <h2 className="text-xl font-bold" data-id="element-1319">Ders Öğretmenleri</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1320">
                {/* Türkçe */}
                <div className="flex flex-col gap-1" data-id="element-1321">
                  <label className="text-sm text-gray-400" data-id="element-1322">Türkçe</label>
                  <select value={subjectTeachers.turkce || ''} onChange={e => handleTeacherChange('turkce', e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 appearance-none" data-id="element-1323">
                    <option value="" data-id="element-1324">Öğretmen Seçiniz</option>
                    {getTeachersByBranch('Türkçe').map(teacher => <option key={teacher.id} value={teacher.id} data-id="element-1325">
                        {teacher.firstName} {teacher.lastName}
                      </option>)}
                  </select>
                </div>
                {/* Matematik */}
                <div className="flex flex-col gap-1" data-id="element-1326">
                  <label className="text-sm text-gray-400" data-id="element-1327">Matematik</label>
                  <select value={subjectTeachers.matematik || ''} onChange={e => handleTeacherChange('matematik', e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 appearance-none" data-id="element-1328">
                    <option value="" data-id="element-1329">Öğretmen Seçiniz</option>
                    {getTeachersByBranch('Matematik').map(teacher => <option key={teacher.id} value={teacher.id} data-id="element-1330">
                        {teacher.firstName} {teacher.lastName}
                      </option>)}
                  </select>
                </div>
                {/* Fen Bilimleri */}
                <div className="flex flex-col gap-1" data-id="element-1331">
                  <label className="text-sm text-gray-400" data-id="element-1332">Fen Bilimleri</label>
                  <select value={subjectTeachers.fenBilimleri || ''} onChange={e => handleTeacherChange('fenBilimleri', e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 appearance-none" data-id="element-1333">
                    <option value="" data-id="element-1334">Öğretmen Seçiniz</option>
                    {getTeachersByBranch('Fen Bilimleri').map(teacher => <option key={teacher.id} value={teacher.id} data-id="element-1335">
                        {teacher.firstName} {teacher.lastName}
                      </option>)}
                  </select>
                </div>
                {/* Sosyal Bilgiler */}
                <div className="flex flex-col gap-1" data-id="element-1336">
                  <label className="text-sm text-gray-400" data-id="element-1337">
                    Sosyal Bilgiler
                  </label>
                  <select value={subjectTeachers.sosyalBilgiler || ''} onChange={e => handleTeacherChange('sosyalBilgiler', e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 appearance-none" data-id="element-1338">
                    <option value="" data-id="element-1339">Öğretmen Seçiniz</option>
                    {getTeachersByBranch('Sosyal Bilgiler').map(teacher => <option key={teacher.id} value={teacher.id} data-id="element-1340">
                        {teacher.firstName} {teacher.lastName}
                      </option>)}
                  </select>
                </div>
                {/* İngilizce */}
                <div className="flex flex-col gap-1" data-id="element-1341">
                  <label className="text-sm text-gray-400" data-id="element-1342">İngilizce</label>
                  <select value={subjectTeachers.ingilizce || ''} onChange={e => handleTeacherChange('ingilizce', e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 appearance-none" data-id="element-1343">
                    <option value="" data-id="element-1344">Öğretmen Seçiniz</option>
                    {getTeachersByBranch('İngilizce').map(teacher => <option key={teacher.id} value={teacher.id} data-id="element-1345">
                        {teacher.firstName} {teacher.lastName}
                      </option>)}
                  </select>
                </div>
                {/* Din Kültürü */}
                <div className="flex flex-col gap-1" data-id="element-1346">
                  <label className="text-sm text-gray-400" data-id="element-1347">Din Kültürü</label>
                  <select value={subjectTeachers.dinKulturu || ''} onChange={e => handleTeacherChange('dinKulturu', e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 appearance-none" data-id="element-1348">
                    <option value="" data-id="element-1349">Öğretmen Seçiniz</option>
                    {getTeachersByBranch('Din Kültürü ve Ahlâk Bilgisi').map(teacher => <option key={teacher.id} value={teacher.id} data-id="element-1350">
                          {teacher.firstName} {teacher.lastName}
                        </option>)}
                  </select>
                </div>
              </div>
            </div>
          </AuroraFloatingCard>
        </div>
      </div>
      {/* Öğrenci Listesi - Ana Odak Noktası */}
      <AuroraFloatingCard data-id="element-1351">
        <div className="p-5 sm:p-6" data-id="element-1352">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-5" data-id="element-1353">
            <div className="flex items-center gap-2" data-id="element-1354">
              <Users className="w-5 h-5 text-blue-400" data-id="element-1355" />
              <h2 className="text-xl font-bold" data-id="element-1356">Öğrenci Listesi</h2>
            </div>
            <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-1357">
              {/* Öğrenci Arama */}
              <div className="relative flex-1 sm:flex-initial" data-id="element-1358">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} data-id="element-1359" />
                <input type="text" placeholder="Öğrenci ara..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-9 pr-4 py-2 w-full sm:w-64 bg-gray-800/50 border border-purple-500/30 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-1360" />
              </div>
              {/* Öğrenci Ekle Butonu */}
              <button onClick={() => setShowAddStudentModal(true)} className="px-3 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:opacity-90 text-white rounded-lg transition-colors flex items-center gap-2 whitespace-nowrap" data-id="element-1361">
                <Plus size={16} data-id="element-1362" />
                <span className="hidden sm:inline" data-id="element-1363">Öğrenci Ekle</span>
              </button>
            </div>
          </div>
          {/* Öğrenci Tablosu */}
          {filteredClassStudents.length === 0 ? <div className="py-8 text-center" data-id="element-1364">
              <Users className="w-16 h-16 text-gray-600 mx-auto mb-4" data-id="element-1365" />
              <p className="text-gray-400 mb-4" data-id="element-1366">
                {searchTerm ? 'Arama kriterlerine uygun öğrenci bulunamadı.' : 'Bu sınıfta henüz öğrenci bulunmuyor.'}
              </p>
              <button onClick={() => setShowAddStudentModal(true)} className="mt-3 px-4 py-2 bg-blue-500/10 hover:bg-blue-500/20 text-blue-400 rounded-lg transition-colors inline-flex items-center gap-2" data-id="element-1367">
                <Plus size={16} data-id="element-1368" />
                <span data-id="element-1369">Öğrenci Ekle</span>
              </button>
            </div> : <div className="overflow-x-auto" data-id="element-1370">
              <table className="w-full" data-id="element-1371">
                <thead data-id="element-1372">
                  <tr className="border-b border-gray-700" data-id="element-1373">
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-300" data-id="element-1374">
                      Öğrenci No
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-300" data-id="element-1375">
                      Adı Soyadı
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-300" data-id="element-1376">
                      Veli Adı
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-300" data-id="element-1377">
                      Veli Telefonu
                    </th>
                    <th className="px-4 py-3 text-right text-sm font-medium text-gray-300" data-id="element-1378">
                      İşlemler
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-1379">
                  {filteredClassStudents.map((student, index) => <tr key={student.id} className="border-b border-gray-800 hover:bg-gray-800/30" data-id="element-1380">
                      <td className="px-4 py-3 text-gray-300" data-id="element-1381">{student.id}</td>
                      <td className="px-4 py-3 text-white" data-id="element-1382">
                        {student.firstName} {student.lastName}
                      </td>
                      <td className="px-4 py-3 text-gray-300" data-id="element-1383">
                        {/* Burada gerçek veli adı olacak, şimdilik örnek */}
                        Veli {student.lastName}
                      </td>
                      <td className="px-4 py-3 text-gray-300" data-id="element-1384">
                        {/* Burada gerçek veli telefonu olacak, şimdilik örnek */}
                        555-{index + 100}-{index + 5000}
                      </td>
                      <td className="px-4 py-3 text-right" data-id="element-1385">
                        <button onClick={() => {
                    setStudentToMove(student);
                    setShowMoveModal(true);
                  }} className="p-1.5 bg-purple-500/10 hover:bg-purple-500/20 text-purple-400 rounded-lg transition-colors" title="Öğrenciyi Taşı" data-id="element-1386">
                          <ArrowLeftRight size={16} data-id="element-1387" />
                        </button>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}
        </div>
      </AuroraFloatingCard>
      {/* Öğrenci Taşıma Modal */}
      {showMoveModal && studentToMove && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm" data-id="element-1388">
          <AuroraFloatingCard className="w-full max-w-md" data-id="element-1389">
            <div className="p-5 sm:p-6" data-id="element-1390">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1391">
                Öğrenciyi Taşı
              </h3>
              <p className="text-gray-300 mb-4" data-id="element-1392">
                <span className="font-medium text-white" data-id="element-1393">
                  {studentToMove.firstName} {studentToMove.lastName}
                </span>{' '}
                isimli öğrenciyi hangi sınıfa taşımak istiyorsunuz?
              </p>
              <div className="space-y-2 max-h-[300px] overflow-y-auto mb-5" data-id="element-1394">
                {classes.filter(c => c.id !== currentClass.id && c.status).map(cls => <button key={cls.id} onClick={() => handleMoveStudent(cls.id)} className="flex justify-between items-center w-full p-3 bg-gray-800/50 hover:bg-gray-700/50 rounded-lg transition-colors" data-id="element-1395">
                      <span className="text-white" data-id="element-1396">{cls.fullName}</span>
                      <MoveRight size={16} className="text-gray-400" data-id="element-1397" />
                    </button>)}
              </div>
              <div className="flex justify-end" data-id="element-1398">
                <button onClick={() => {
              setShowMoveModal(false);
              setStudentToMove(null);
            }} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors" data-id="element-1399">
                  İptal
                </button>
              </div>
            </div>
          </AuroraFloatingCard>
        </div>}
      {/* Öğrenci Ekleme Modal */}
      {showAddStudentModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm" data-id="element-1400">
          <AuroraFloatingCard className="w-full max-w-md" data-id="element-1401">
            <div className="p-5 sm:p-6" data-id="element-1402">
              <div className="flex justify-between items-center mb-4" data-id="element-1403">
                <h3 className="text-xl font-bold text-white" data-id="element-1404">Öğrenci Ekle</h3>
                <button onClick={() => setShowAddStudentModal(false)} className="text-gray-400 hover:text-white transition-colors" data-id="element-1405">
                  <X size={20} data-id="element-1406" />
                </button>
              </div>
              {unassignedStudents.length === 0 ? <div className="py-8 text-center" data-id="element-1407">
                  <p className="text-gray-400" data-id="element-1408">
                    Eklenebilecek öğrenci bulunmuyor. Tüm öğrenciler bir sınıfa
                    atanmış.
                  </p>
                </div> : <>
                  <p className="text-gray-300 mb-4" data-id="element-1409">
                    {currentClass.fullName} sınıfına eklemek istediğiniz
                    öğrenciyi seçin:
                  </p>
                  <div className="space-y-2 max-h-[300px] overflow-y-auto mb-5" data-id="element-1410">
                    {unassignedStudents.map(student => <button key={student.id} onClick={() => handleAddStudent(student.id)} className="flex justify-between items-center w-full p-3 bg-gray-800/50 hover:bg-gray-700/50 rounded-lg transition-colors" data-id="element-1411">
                        <span className="text-white" data-id="element-1412">
                          {student.firstName} {student.lastName}
                        </span>
                        <Plus size={16} className="text-gray-400" data-id="element-1413" />
                      </button>)}
                  </div>
                </>}
              <div className="flex justify-end" data-id="element-1414">
                <button onClick={() => setShowAddStudentModal(false)} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors" data-id="element-1415">
                  Kapat
                </button>
              </div>
            </div>
          </AuroraFloatingCard>
        </div>}
      {/* Sınıf Düzenleme Modal */}
      {showEditModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm" data-id="element-1416">
          <AuroraFloatingCard className="w-full max-w-md" data-id="element-1417">
            <div className="p-5 sm:p-6" data-id="element-1418">
              <div className="flex justify-between items-center mb-4" data-id="element-1419">
                <h3 className="text-xl font-bold text-white" data-id="element-1420">
                  Sınıf Bilgilerini Düzenle
                </h3>
                <button onClick={() => setShowEditModal(false)} className="text-gray-400 hover:text-white transition-colors" data-id="element-1421">
                  <X size={20} data-id="element-1422" />
                </button>
              </div>
              <div className="space-y-4" data-id="element-1423">
                {/* Sınıf Seviyesi */}
                <div data-id="element-1424">
                  <label className="block text-sm font-medium text-gray-300 mb-1" data-id="element-1425">
                    Sınıf Seviyesi <span className="text-red-500" data-id="element-1426">*</span>
                  </label>
                  <select value={editFormData.grade} onChange={e => setEditFormData({
                ...editFormData,
                grade: e.target.value
              })} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-1427">
                    {gradeOptions.map(option => <option key={option} value={option} data-id="element-1428">
                        {option}
                      </option>)}
                  </select>
                </div>
                {/* Şube */}
                <div data-id="element-1429">
                  <label className="block text-sm font-medium text-gray-300 mb-1" data-id="element-1430">
                    Şube <span className="text-red-500" data-id="element-1431">*</span>
                  </label>
                  <select value={editFormData.section} onChange={e => setEditFormData({
                ...editFormData,
                section: e.target.value
              })} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-1432">
                    {sectionOptions.map(option => <option key={option} value={option} data-id="element-1433">
                        {option}
                      </option>)}
                  </select>
                </div>
                {/* Sınıf Danışmanı */}
                <div data-id="element-1434">
                  <label className="block text-sm font-medium text-gray-300 mb-1" data-id="element-1435">
                    Sınıf Danışmanı
                  </label>
                  <select value={editFormData.classTeacherId} onChange={e => setEditFormData({
                ...editFormData,
                classTeacherId: e.target.value
              })} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-1436">
                    <option value="" data-id="element-1437">Seçiniz...</option>
                    {teachers.filter(teacher => teacher.status).map(teacher => <option key={teacher.id} value={teacher.id} data-id="element-1438">
                          {teacher.firstName} {teacher.lastName} (
                          {teacher.branch})
                        </option>)}
                  </select>
                </div>
              </div>
              <div className="flex justify-end gap-3 mt-6" data-id="element-1439">
                <button onClick={() => setShowEditModal(false)} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors" data-id="element-1440">
                  İptal
                </button>
                <button onClick={handleEditClass} className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:opacity-90 text-white rounded-lg transition-colors" data-id="element-1441">
                  Kaydet
                </button>
              </div>
            </div>
          </AuroraFloatingCard>
        </div>}
      {/* Sınıf Silme Onay Modal */}
      {showDeleteModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm" data-id="element-1442">
          <AuroraFloatingCard className="w-full max-w-md" data-id="element-1443">
            <div className="p-5 sm:p-6" data-id="element-1444">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1445">Sınıfı Sil</h3>
              <p className="text-gray-300 mb-6" data-id="element-1446">
                <span className="font-semibold text-purple-400" data-id="element-1447">
                  {currentClass.fullName}
                </span>{' '}
                sınıfını kalıcı olarak silmek istediğinize emin misiniz? Bu
                işlem geri alınamaz ve sınıftaki tüm öğrenci atamaları
                kaldırılacaktır.
              </p>
              <div className="flex justify-end gap-3" data-id="element-1448">
                <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors" data-id="element-1449">
                  İptal
                </button>
                <button onClick={handleDeleteClass} className="px-4 py-2 bg-gradient-to-r from-red-500 to-pink-600 hover:opacity-90 text-white rounded-lg transition-colors" data-id="element-1450">
                  Evet, Kalıcı Olarak Sil
                </button>
              </div>
            </div>
          </AuroraFloatingCard>
        </div>}
    </div>;
};
export function SinifYonetimi() {
  const [classes, setClasses] = useState<Class[]>(initialClasses);
  const [teachers] = useState<Teacher[]>(mockTeachers);
  const [students, setStudents] = useState<Student[]>(mockStudents);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedGrade, setSelectedGrade] = useState<string>('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentClass, setCurrentClass] = useState<Class | null>(null);
  // Form state'i
  const [formData, setFormData] = useState({
    grade: gradeOptions[0],
    section: sectionOptions[0],
    location: '',
    classTeacherId: ''
  });
  // Form validasyon hataları
  const [formErrors, setFormErrors] = useState({
    grade: '',
    section: ''
  });
  // URL'den sınıf ID'sini al
  const urlParts = window.location.pathname.split('/');
  const classIdFromUrl = urlParts.length > 3 ? parseInt(urlParts[3]) : null;
  // Form değişikliklerini işleme
  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    // Validasyon
    if (name === 'grade' || name === 'section') {
      if (!value) {
        setFormErrors(prev => ({
          ...prev,
          [name]: `${name === 'grade' ? 'Sınıf seviyesi' : 'Şube'} alanı zorunludur`
        }));
      } else {
        setFormErrors(prev => ({
          ...prev,
          [name]: ''
        }));
      }
    }
  }, []);
  // Sınıf ekleme modalı
  const renderClassFormModal = () => <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm" data-id="element-1451">
      <AuroraFloatingCard className="w-full max-w-lg" data-id="element-1452">
        <div className="p-6" data-id="element-1453">
          <div className="flex justify-between items-center mb-6" data-id="element-1454">
            <h3 className="text-xl font-bold text-white" data-id="element-1455">Yeni Sınıf Ekle</h3>
            <button onClick={() => setShowAddModal(false)} className="text-gray-400 hover:text-white transition-colors" type="button" data-id="element-1456">
              <X size={24} data-id="element-1457" />
            </button>
          </div>
          <div className="space-y-4" data-id="element-1458">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1459">
              {/* Sınıf Seviyesi */}
              <div data-id="element-1460">
                <label htmlFor="grade" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-1461">
                  Sınıf Seviyesi <span className="text-red-500" data-id="element-1462">*</span>
                </label>
                <div className="relative" data-id="element-1463">
                  <select id="grade" name="grade" value={formData.grade} onChange={handleInputChange} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 appearance-none pr-10" data-id="element-1464">
                    {gradeOptions.map(option => <option key={option} value={option} className="bg-gray-800 text-white" data-id="element-1465">
                        {option}
                      </option>)}
                  </select>
                </div>
              </div>
              {/* Şube */}
              <div data-id="element-1466">
                <label htmlFor="section" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-1467">
                  Şube <span className="text-red-500" data-id="element-1468">*</span>
                </label>
                <div className="relative" data-id="element-1469">
                  <select id="section" name="section" value={formData.section} onChange={handleInputChange} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 appearance-none pr-10" data-id="element-1470">
                    {sectionOptions.map(option => <option key={option} value={option} className="bg-gray-800 text-white" data-id="element-1471">
                        {option}
                      </option>)}
                  </select>
                </div>
              </div>
              {/* Sınıf Öğretmeni */}
              <div className="md:col-span-2" data-id="element-1472">
                <label htmlFor="classTeacherId" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-1473">
                  Sınıf Danışmanı
                </label>
                <div className="relative" data-id="element-1474">
                  <select id="classTeacherId" name="classTeacherId" value={formData.classTeacherId} onChange={handleInputChange} className="w-full bg-gray-800/50 border border-purple-500/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 appearance-none pr-10" data-id="element-1475">
                    <option value="" className="bg-gray-800 text-white" data-id="element-1476">
                      Seçiniz...
                    </option>
                    {teachers.filter(teacher => teacher.status).map(teacher => <option key={teacher.id} value={teacher.id.toString()} className="bg-gray-800 text-white" data-id="element-1477">
                          {teacher.firstName} {teacher.lastName} (
                          {teacher.branch})
                        </option>)}
                  </select>
                </div>
              </div>
            </div>
            <div className="flex justify-end gap-3 mt-6" data-id="element-1478">
              <button type="button" onClick={() => setShowAddModal(false)} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors" data-id="element-1479">
                İptal
              </button>
              <button type="button" onClick={handleSaveClass} className="px-4 py-2 bg-gradient-to-r from-purple-600 to-blue-600 hover:opacity-90 text-white rounded-lg transition-colors" data-id="element-1480">
                Kaydet
              </button>
            </div>
          </div>
        </div>
      </AuroraFloatingCard>
    </div>;
  // Sınıf ekleme veya güncelleme
  const handleSaveClass = () => {
    const fullName = `${formData.grade}-${formData.section}`;
    // Aynı isimde sınıf var mı kontrol et
    const duplicateCheck = classes.find(cls => cls.fullName === fullName && cls.status);
    if (duplicateCheck) {
      alert(`${fullName} sınıfı zaten mevcut!`);
      return;
    }
    // Yeni sınıf ekle
    const newClass: Class = {
      id: Math.max(...classes.map(c => c.id), 0) + 1,
      grade: formData.grade,
      section: formData.section,
      fullName: fullName,
      location: formData.location,
      classTeacherId: formData.classTeacherId ? parseInt(formData.classTeacherId) : null,
      studentCount: 0,
      status: true
    };
    setClasses([...classes, newClass]);
    // Modalı kapat ve formu sıfırla
    setShowAddModal(false);
    setFormData({
      grade: gradeOptions[0],
      section: sectionOptions[0],
      location: '',
      classTeacherId: ''
    });
  };
  // Sınıf silme
  const handleDeleteClass = () => {
    if (currentClass) {
      const updatedClasses = classes.map(cls => cls.id === currentClass.id ? {
        ...cls,
        status: false
      } : cls);
      setClasses(updatedClasses);
      setShowDeleteModal(false);
      setCurrentClass(null);
    }
  };
  return <div className="space-y-6 p-4" data-id="element-1481">
      {/* Başlık */}
      <div className="flex items-center gap-3" data-id="element-1482">
        <h1 className="text-3xl font-bold" data-id="element-1483">Sınıf Yönetimi</h1>
        <BookOpen className="w-8 h-8 text-blue-400" data-id="element-1484" />
      </div>
      {/* Ana Kart */}
      <AuroraFloatingCard data-id="element-1485">
        {classIdFromUrl ? <ClassDetailView classId={classIdFromUrl} classes={classes} setClasses={setClasses} teachers={teachers} students={students} setStudents={setStudents} data-id="element-1486" /> : <ClassListView classes={classes} teachers={teachers} searchTerm={searchTerm} setSearchTerm={setSearchTerm} selectedGrade={selectedGrade} setSelectedGrade={setSelectedGrade} setShowAddModal={setShowAddModal} data-id="element-1487" />}
      </AuroraFloatingCard>
      {/* Modaller */}
      {showAddModal && renderClassFormModal()}
      {showDeleteModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm" data-id="element-1488">
          <AuroraFloatingCard className="w-full max-w-md" data-id="element-1489">
            <div className="p-6" data-id="element-1490">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1491">
                Sınıfı Pasif Yap
              </h3>
              <p className="text-gray-300 mb-6" data-id="element-1492">
                <span className="font-semibold text-purple-400" data-id="element-1493">
                  {currentClass?.fullName}
                </span>{' '}
                sınıfını pasif duruma getirmek istediğinize emin misiniz? Bu
                işlemden sonra sınıf listelerde görünmeyecek ancak sistem
                kayıtlarında tutulacaktır.
              </p>
              <div className="flex justify-end gap-3" data-id="element-1494">
                <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors" data-id="element-1495">
                  İptal
                </button>
                <button onClick={handleDeleteClass} className="px-4 py-2 bg-gradient-to-r from-red-500 to-pink-600 hover:opacity-90 text-white rounded-lg transition-colors" data-id="element-1496">
                  Pasif Yap
                </button>
              </div>
            </div>
          </AuroraFloatingCard>
        </div>}
    </div>;
}